export function customVideo() {
    let isPause = true;
    let tick;
    const videoBlocks = $('.video-block .video-wrap');
    const videoNavButtons = $('.video-nav .video-nav-button');

    videoBlocks.each(function(index) {
        const videoBlock = $(this);
        const videoNavButton = videoNavButtons.eq(index);
        const progressContainer = videoBlock.find('.video-progress');
        const progress = progressContainer.find('.progress');
        const video = videoBlock.find("video").get(0);
        const currentTimeDisplay = videoBlock.find('.current');
        const totalTimeDisplay = videoBlock.find('.length');

        setVideoSrc(videoBlock);

        videoNavButton.attr("aria-label", "Play");

        videoNavButton.on("click", function () {
            if (video.paused) {
                playVideo(video, videoNavButton);
            } else {
                pauseVideo(video, videoNavButton);
            }
        });

        progressContainer.on('click', function(e) {
            const offset = $(this).offset();
            const posX = e.pageX - offset.left;
            const width = $(this).width();
            const newTime = (posX / width) * video.duration;
            video.currentTime = newTime;
            // Update the progress bar and time display immediately after changing the time
            updateProgressBar(progress, video);
            updateTimeDisplay(currentTimeDisplay, totalTimeDisplay, video);
        });

        video.addEventListener('timeupdate', function() {
            if (!isPause) {
                updateProgressBar(progress, video);
                updateTimeDisplay(currentTimeDisplay, totalTimeDisplay, video);
            }
        });

        video.addEventListener('loadedmetadata', function() {
            // Update the total time display when metadata is loaded
            updateTimeDisplay(currentTimeDisplay, totalTimeDisplay, video);
        });

        function startProgressbar(progress, video) {
            tick = setInterval(function() {
                updateProgressBar(progress, video);
                updateTimeDisplay(currentTimeDisplay, totalTimeDisplay, video);
            }, 100);
        }

        function updateProgressBar(progress, video) {
            const percentTime = (video.currentTime / video.duration) * 100;
            progress.css('width', percentTime + '%');
        }

        function resetProgressbar(progress) {
            progress.css('width', '0%');
        }

        function playVideo(video, button) {
            video.play();
            button.removeClass('paused').attr("aria-label", "Pause");
            isPause = false;
            startProgressbar(progress, video);
        }

        function pauseVideo(video, button) {
            video.pause();
            button.addClass('paused').attr("aria-label", "Play");
            isPause = true;
            clearInterval(tick);
        }

        function setVideoSrc(videoBlock) {
            const video = videoBlock.find("video").get(0);

            if (video && !video.src) {
                video.src = video.dataset.src;
            }
        }

        function updateTimeDisplay(current, total, video) {
            current.text(formatTime(video.currentTime));
            total.text(formatTime(video.duration));
        }

        function formatTime(seconds) {
            const minutes = Math.floor(seconds / 60);
            const remainingSeconds = Math.floor(seconds % 60);
            return minutes + ':' + (remainingSeconds < 10 ? '0' : '') + remainingSeconds;
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/customVideo.js